export default __webpack_public_path__ + "static/media/refresh_light.f3b726fd.svg";